"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  flex: 1 1 auto;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-self: stretch;\n  align-items: center;\n  margin-bottom: 1rem;\n\n  @media (min-width: ", ") {\n    align-items: flex-start;\n    margin-bottom: 0;\n  }\n\n  @media (min-width: ", ") {\n    align-items: flex-start;\n    margin-right: 1rem;\n    margin-bottom: 0;\n  }\n"])), function (props) {
  return props.theme.screenWidthXxs;
}, function (props) {
  return props.theme.screenWidthMd;
});

var Wrapper = function Wrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react.default.createElement(StyledWrapper, null, children);
};

var _default = Wrapper;
exports.default = _default;